var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOfferingProduct = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 21.681V3.392A2.39 2.39 0 0 1 3.392 1H20.14a2.39 2.39 0 0 1 2.392 2.392v11.962a2.39 2.39 0 0 1-2.392 2.392H6.935c-.727 0-1.415.33-1.869.898L2.278 22.13C1.854 22.66 1 22.36 1 21.68"
})));
export default SvgOfferingProduct;